import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { Box, Typography, Button } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import React from 'react'

const Spinner = ({ open, hasError = false, errorMessage = "Unexpected error occurred, try again later", children }) => {

  const [openModal, setOpenModal] = React.useState(false)

  React.useEffect(() => {
    if (hasError) return setOpenModal(true)

    if (open && !hasError) return  setOpenModal(true)
  
    if (open === false) return setOpenModal(false)
  }, [open, hasError])

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1_000 }}
      open={openModal}
    >
      {!hasError && <CircularProgress color='inherit' />}
      {hasError && (
        <Box
          sx={{
            bgcolor: 'background.paper',
            borderRadius: 2,
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: 400
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
          <Typography variant="h6" component="h2" sx={{ mb: 2, color: 'text.primary', textAlign: 'center' }}>
            {errorMessage}
          </Typography>
          { children }
          {/* {onRetry && (
            <Button
              variant="contained"
              color="primary"
              onClick={onRetry}
              sx={{ mt: 2 }}
            >
              Retry
            </Button>
          )} */}
        </Box>
      )}
    </Backdrop>
  )
}

export default Spinner
